namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_entity_page, {
		
		flex: {
			grow: 1,
		},
		
	} )
	
}
